import { render, staticRenderFns } from "./footerMobile.vue?vue&type=template&id=2dc26215&scoped=true"
import script from "./footerMobile.vue?vue&type=script&lang=js"
export * from "./footerMobile.vue?vue&type=script&lang=js"
import style0 from "./footerMobile.vue?vue&type=style&index=0&id=2dc26215&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc26215",
  null
  
)

export default component.exports